const styles = () => ({
  container: {
    display: 'flex',
    alignItems: 'center'
  }
})

export default styles
